import React from 'react';
import { Checkbox, Radio } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Presence } from '@/components/Presence/Presence';
import { EPresenceStatusApi } from '@/shared/enums/presence.enum';
import { AgentListMode } from '@/components/AgentList/AgentList';
import './Agent.scss';

interface AgentProps {
  extension: string;
  userName: string;
  presenceStatus: EPresenceStatusApi;
  mode: AgentListMode;
  checked?: boolean;
  multipleSelect?: boolean;
  onChange?: (event: CheckboxChangeEvent) => void;
}

export function Agent({
  extension,
  userName,
  presenceStatus,
  mode,
  multipleSelect,
  onChange,
  checked,
}: AgentProps) {
  const onCheckboxChange = (event: CheckboxChangeEvent) => {
    onChange(event);
  };

  const disabled =
    (mode === 'addToGroupCall' &&
      presenceStatus !== EPresenceStatusApi.AVAILABLE) ||
    (mode === 'onCall' &&
      ![EPresenceStatusApi.AVAILABLE, EPresenceStatusApi.ON_A_CALL].includes(
        presenceStatus,
      ));

  return (
    <div className="agent">
      {multipleSelect ? (
        <div className="checkbox-wrap">
          {mode !== 'onCall' && (
            <Checkbox
              checked={checked}
              value={extension}
              onChange={onCheckboxChange}
              disabled={disabled}
            ></Checkbox>
          )}
          <span className="username" title={userName}>
            {userName}
          </span>
        </div>
      ) : (
        <Radio value={extension}>{userName}</Radio>
      )}
      <Presence status={presenceStatus} isSelectable={false}></Presence>
    </div>
  );
}
